export const basicChipColours = [
    {name: "green", hex: "#198f19"},
    {name: "red", hex: "#c11010"},
    {name: "blue", hex: "#1111bb"},
    {name: "black", hex: "#1d1b1b"},
    {name: "white", hex: "#f7f7f7"},
    {name: "default", hex: "grey"},
  ]